import script from "./PromotionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionModal.vue?vue&type=script&setup=true&lang=js"

import "./PromotionModal.vue?vue&type=style&index=0&id=a903da44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a903da44"]])

export default __exports__